export default __webpack_public_path__ + "static/media/redux.71eb13e2.svg";